"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.TransactionReducer = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _filterClasses = require("../components/transaction/filterClasses");

var _apiCustomerTransactions = require("../actions/esdb/apiCustomerTransactions");

var _apiTransactionFullTrNumber = require("../actions/esdb/apiTransactionFullTrNumber");

var _apiTransactionSetStatus = require("../actions/esdb/apiTransactionSetStatus");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EmbeddedDocumentLists = {
	"STOCK": "STOCK_ID",
	"SUPPLIERS": "SUPPLIER_ID",
	"SELLING_PLATFORMS": "SELLING_PLATFORM"
};

var TransactionMergeWithCustomizer = function TransactionMergeWithCustomizer(objValue, srcValue, key) {
	if (_lodash2.default.isArray(objValue)) {
		if (_lodash2.default.get(EmbeddedDocumentLists, key, null) != null) {
			return Object.values(_lodash2.default.assign({}, _lodash2.default.keyBy(objValue, function (i) {
				return i[EmbeddedDocumentLists[key]];
			}), _lodash2.default.keyBy(srcValue, function (i) {
				return i[EmbeddedDocumentLists[key]];
			})));
		}
		return _lodash2.default.unionWith(objValue, srcValue, _lodash2.default.isEqual);
	}
};

var TransactionReducer = exports.TransactionReducer = function TransactionReducer() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	var action = arguments[1];


	switch (action.type) {
		case _apiTransactionFullTrNumber.API_TRANSACTION_FULL_TR_NUMBER_SUCCESS:
		case _apiTransactionSetStatus.API_TRANSACTION_SET_STATUS_SUCCESS:
		case _apiCustomerTransactions.API_CUSTOMER_TRANSACTIONS_SUCCESS:

			console.log(action.payload.data);

			var ret_data = {};
			// Get Timestamp to set expire date
			var timesStamp = new Date().getTime();

			Object.entries(action.payload.data.TRANSACTIONS).map(function (_ref) {
				var _ref2 = _slicedToArray(_ref, 2),
				    FULL_TR_NUMBER = _ref2[0],
				    TR_DATA = _ref2[1];

				var filterClass = !_lodash2.default.isUndefined(state[FULL_TR_NUMBER]) ? Object.assign({}, state[FULL_TR_NUMBER].filterClass) : {};

				_filterClasses.filterClasses[action.payload.data.FILTER_CLASS].map(function (entry) {
					return filterClass[entry] = timesStamp;
				});

				ret_data[FULL_TR_NUMBER] = {
					loading: action.payload.loading,
					error: action.payload.error,
					data: TR_DATA,
					filterClass: filterClass
				};
			});

			// Merge reduced transactions
			var merged = _lodash2.default.mergeWith({}, state, ret_data, TransactionMergeWithCustomizer);

			var overWritePaths = [];
			var pick = null;
			var newSKUData = {};

			Object.keys(ret_data).map(function (FULL_TR_NUMBER) {
				pick = _lodash2.default.pick(ret_data[FULL_TR_NUMBER].data, overWritePaths);
				newSKUData = _lodash2.default.assign({}, merged[FULL_TR_NUMBER].data, pick);
				merged[FULL_TR_NUMBER].data = newSKUData;
			});

			return merged;

		default:
			return state;
	}
};